export const getDistinctBrands = products => [
  ...new Set(products.map(({ brandName }) => brandName))
];
